import Vue from 'vue'

/** Import mixins auto */
const requireMixin = require.context(
  '@/mixins', false, /[\w-]+\.js$/
)
requireMixin.keys().forEach(fileName => {
  const mixinConfig = requireMixin(fileName)
  Vue.mixin(mixinConfig.default)
})



// WEBPACK FOOTER //
// ./src/plugins/mixins.js